import request from '@/utils/request.js'

//基本信息
export function userInfo() {
    return request({
        url: '/user/info',
        method: 'GET',
    })
}


//修改基本信息
export function changeUserInfo(nickname, phone, avatar) {
    return request({
        url: '/user/info',
        method: 'PUT',
        params: { nickname: nickname, phone: phone, avatar: avatar }
    })
}
 

//修改用户昵称
export function changeUserNickName(nickname){
    return request({
        url: '/user/info',
        method: 'PUT',
        params: { nickname: nickname}
    })
}


//修改用户昵称和头像
export function changeUserNickNameAvatar(nickname,avatar){
    return request({
        url: '/user/info',
        method: 'PUT',
        params: { nickname: nickname,avatar:avatar}
    })
}


//修改密码
export function changePwd(old_pass, new_pass) {
    return request({
        url: '/user/pass',
        method: 'PUT',
        params: { old_pass: old_pass, new_pass: new_pass }
    })
}


//课程列表
export function coursesList(page,pageSize){
    return request({
        url: '/user/courses',
        method: 'GET',
        params: { page: page, pageSize: pageSize }
    })
}


//收藏资讯列表
export function favNewsList(page,pageSize){
    return request({
        url: '/user/collections/news',
        method: 'GET',
        params: { page: page, pageSize: pageSize }
    })
}


//收藏课程列表
export function favCoursesList(page,pageSize){
    return request({
        url: '/user/collections/courses',
        method: 'GET',
        params: { page: page, pageSize: pageSize }
    })
}


//收藏课程包列表
export function favCoursesPkgList(page,pageSize){
    return request({
        url: '/user/collections/course-pkg',
        method: 'GET',
        params: { page: page, pageSize: pageSize }
    })
}


//添加课程收藏
export function addCourseFav(id){
    return request({
        url: '/user/collections/flow',
        method: 'POST',
        params: { id: id, type: 1 }
    })
}

//添加资讯收藏
export function addNewsFav(id){
    return request({
        url: '/user/collections/flow',
        method: 'POST',
        params: { id: id, type: 2 }
    })
}
//添加课程包收藏
export function addCoursePkgFav(id){
    return request({
        url: '/user/collections/flow',
        method: 'POST',
        params: { id: id, type: 3 }
    })
}



//取消课程收藏
export function deleteCourseFav(id){
    return request({
        url: '/user/collections/flow',
        method: 'DELETE',
        params: { id: id, type: 1 }
    })
}

//取消课程包收藏
export function deleteCoursePkgFav(id){
    return request({
        url: '/user/collections/flow',
        method: 'DELETE',
        params: { id: id, type: 3 }
    })
}

//取消新闻收藏
export function deleteNewsFav(id){
    return request({
        url: '/user/collections/flow',
        method: 'DELETE',
        params: { id: id, type: 2 }
    })
} 

//消费记录
export function consumes(page){
    return request({
        url: '/user/assets/consumes',
        method: 'get',
        params: { page: page, pageSize: 10 }
    })
} 


//未读消息列表
export function notReadMessages(page,pageSize){
   return messages(page,pageSize,0);
} 


//已读消息列表
export function readedMessages(page,pageSize){
    return messages(page,pageSize,1);
} 

//获取所有类型的消息列表
export function messageList(page,pageSize){
    return request({
        url: '/user/messages',
        method: 'GET',
        params: { page: page, pageSize: pageSize}
    })
} 

//消息列表
export function messages(page,pageSize,status){
    return request({
        url: '/user/messages',
        method: 'GET',
        params: { page: page, pageSize: pageSize,status:status }
    })
} 



//消息条数
export function messageQty(status){
    return request({
        url: '/user/messages/count',
        method: 'GET',
        params: {status:status }
    })
} 

//消息详情
export function messageDetail(id){
    return request({
        url: '/user/messages/detail',
        method: 'GET',
        params: { id: id}
    })
} 
//设置消息已读
export function setMsgReaded(id){
    return request({
        url: 'api/user/messages/status',
        method: 'PUT',
        params: { id: id}
    })
} 
 

//已读消息条数
export function readedMessageQty(){
    return messageQty(1);
}

//未读消息条数
export function notReadMessageQty(){
    return messageQty(0);
}

//资产
export function assets(){
    return request({
        url: '/user/assets',
        method: 'GET',
    })
}

///////充值相关/////////
//充值记录
export function recharge(page,pageSize){
    return request({
        url: '/user/assets/recharges',
        method: 'GET',
        params: { page: page, pageSize: pageSize }
    })
}

///////优惠相关////////
//领取优惠券
export function receiveCoupon(id){
    return request({
        url: '/user/coupons/receive',
        method: 'GET',
        params:{id:id}
    })
}

//获取所有优惠券
export function couponsList(page,pageSize){
    return request({
        url: '/user/coupons',
        method: 'GET',
        params:{page:page,pageSize:pageSize}
    })
}

//获取未使用的优惠券列表
export function couponsListByUnUse(page,pageSize){
    return request({
        url: '/user/coupons',
        method: 'GET',
        params:{use_status:0,page:page,pageSize:pageSize,is_valid:0}
    })
}
//获取已使用的优惠券列表
export function couponsListByUsed(page,pageSize){
    return request({
        url: '/user/coupons',
        method: 'GET',
        params:{use_status:1,page:page,pageSize:pageSize}
    })
}
//获取未过期的优惠券列表
export function couponsListByValid(page,pageSize){
    return request({
        url: '/user/coupons',
        method: 'GET',
        params:{is_valid:0,page:page,pageSize:pageSize}
    })
}

//获取已过期的优惠券列表
export function couponsListByInvalid(page,pageSize){
    return request({
        url: '/user/coupons',
        method: 'GET',
        params:{is_valid:1,page:page,pageSize:pageSize}
    })
}
 